import script from "./MaterialMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./MaterialMultiSelect.vue?vue&type=style&index=0&id=4c6bf082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6bf082"]])

export default __exports__